import { ThemeUICSSObject, spacing } from '@apia/theme';

/* IMPORT HERE */

const selectedFunc: ThemeUICSSObject = {
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: 3,

  '.noNodes ~ &': {
    display: 'none',
  },

  '&.hidden': {
    display: 'none',
  },

  '&.searchContainer': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    background: 'palette.background.paper',
    position: 'sticky',
    top: 0,
  },
  '& .searchBar': {
    borderColor: 'palette.border.section',
    width: '50vh',
  },

  '.tree__Container': {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    '.tree': {
      py: spacing(3),
      minHeight: '53px',
    },
    '& span': {
      flexShrink: 0,
    },
    ul: {
      overflow: 'hidden',
      m: 0,
    },

    '.closeBtn': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      '& span': {
        fontWeight: '400',
      },
    },
    '.tree__expandIcon': { cursor: 'pointer' },

    '.tree__nodeItemLabelRenderer': {
      display: 'flex',
      gap: 3,
      py: 2,
      alignItems: 'center',
    },
  },
};

export default selectedFunc;
